/*!
    * @product/scmp-sdk 1.1.36
    * built by undefined
  */
var e=Object.defineProperty;var g=Object.getOwnPropertyDescriptor;var h=Object.getOwnPropertyNames;var i=Object.prototype.hasOwnProperty;var k=(b,a)=>()=>(b&&(a=b(b=0)),a);var l=(b,a)=>{for(var d in a)e(b,d,{get:a[d],enumerable:!0})},j=(b,a,d,f)=>{if(a&&typeof a=="object"||typeof a=="function")for(let c of h(a))!i.call(b,c)&&c!==d&&e(b,c,{get:()=>a[c],enumerable:!(f=g(a,c))||f.enumerable});return b};var m=b=>j(e({},"__esModule",{value:!0}),b);export{k as a,l as b,m as c};
//# sourceMappingURL=chunk-TXS2GLIE.js.map
